import { httpReducer } from "../lib/create-action";
import { ADVERTISER_SIGN_UP } from "../action_managers/advertiser_contact";

const initialState = { isLoading: false, validationErrors: [] };
const advertiserSignUp = httpReducer(ADVERTISER_SIGN_UP, initialState, {
  success: state => ({
    ...state,
  }),
  failureBadRequest: (state, action) => {
    return {
      ...state,
      validationErrors: action.payload?.validationErrors,
    };
  },
});

export default advertiserSignUp;
